export const VARIANTS_KEY = 'variants';
export const DEFAULT_TEASER_ID = 'default';
export const SEO_TEASER_ID = 'seo';
export const SOCIAL_TEASER_ID = 'opengraph';
